export enum MapWorkingMode {
  EDIT = "EDIT",
  BOOK = "BOOK",
}
